import { AppButton } from "@/shared/Components";
import { PlusIcon } from "@/shared/icons";
import { useConnectionsTable } from "../../lib";
import { MobileRecord } from "../MobileRecord";
import styles from "./styles.module.scss";

export const Mobile = () => {
  const { methods, state } = useConnectionsTable();
  const { tableData } = state;
  const { openEditModal, setSelectedConnectionsIds, openCreateModal, openDeleteModal } = methods;

  const editHandler = (connectionId: string) => {
    setSelectedConnectionsIds([connectionId]);
    openEditModal();
  };

  const deleteHandler = (connectionId: string) => {
    setSelectedConnectionsIds([connectionId]);
    openDeleteModal();
  };

  return (
    <div className={styles["root"]}>
      {tableData.map((item) => {
        return (
          <MobileRecord
            additionalInfo={item.additionalInfo}
            connectedAs={item.personConnectionType?.name}
            onClickDelete={() => deleteHandler(item.id)}
            onClickEdit={() => editHandler(item.id)}
            person={item.connectionPerson}
            key={item.id}
          />
        );
      })}
      <div className={styles["create-button"]}>
        <AppButton onClick={openCreateModal} type="primary" className={styles.float}>
          <PlusIcon className={styles.icon} />
        </AppButton>
      </div>
    </div>
  );
};
